import PropTypes from "prop-types";
import { useEffect, useState, createRef } from "react";
import useImageWrapper from "helpers/hooks/useImageWrapper";
import Title from "components/shared/stays/Title";
import ButtonImage from "solar/components/ButtonImage";
import ModalFull from "components/shared/stays/ModalFull";
import Carousel from "components/shared/stays/Carousel";
import Container from "solar/components/Container";
import Truncate from "solar/components/Truncate";
import Photo from "components/shared/stays/Photo";
import styles from "components/stay/SurfBreaks.module.scss";

export default function SurfBreaks({ isVisible, breaks }) {
  const onlyCompleteBreaks = breaks?.filter(
    (b) => b.image && b.description && b.direction && b.break_type
  );
  const filteredBreaks = isVisible ? onlyCompleteBreaks : breaks;
  const { getImageWidth } = useImageWrapper();
  const [imgWidths, setImgWidths] = useState([0]);
  const imgWrapperRefs = filteredBreaks?.map(() => createRef(null));
  const [showModal, setShowModal] = useState(false);
  const handleModalClose = () => setShowModal(false);
  const [anchor, setAnchor] = useState(null);

  useEffect(() => {
    const calculatedWidth = getImageWidth(imgWrapperRefs);
    setImgWidths(calculatedWidth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleModalShow(p, idx) {
    setShowModal(true);

    if (idx === 0) {
      setAnchor(null);
    } else setAnchor(p);
  }

  return (
    <>
      <div className={styles.component}>
        <Carousel slidePerLg={3} title={<Title>Breaks</Title>}>
          {filteredBreaks?.map((b, idx) => (
            <div key={b.id}>
              <div className={styles.visual} ref={imgWrapperRefs[idx]}>
                <ButtonImage onClick={() => handleModalShow(b.id, idx)}>
                  {b.image?.url && (
                    <Photo
                      src={b.image?.url}
                      alt={b.name}
                      layout="fill"
                      objectFit="cover"
                      containerWidth={imgWidths && imgWidths[idx]}
                    />
                  )}
                </ButtonImage>
              </div>
              <div className={styles.text}>
                <div className={styles.name}>{b.name}</div>
                <div className={styles.meta}>
                  {[b.direction, b.break_type]?.filter((n) => n).join(", ")}
                </div>
              </div>
            </div>
          ))}
        </Carousel>
      </div>
      <ModalFull
        show={showModal}
        handleClose={handleModalClose}
        scroll
        anchor={anchor}
      >
        <div className={styles.wrapper}>
          <Container>
            <Title size={4}>
              {filteredBreaks?.length}
              {" nearby breaks"}
            </Title>
            <div className={styles.grid}>
              {filteredBreaks?.map((b) => (
                <div key={b.id} className={styles.block} id={b.id}>
                  <div className={styles.media}>
                    {b.image?.url && (
                      <Photo
                        src={b.image?.url}
                        alt={b.name}
                        layout="fill"
                        objectFit="cover"
                      />
                    )}
                  </div>
                  <div className={styles.text}>
                    <div className={styles.name}>{b.name}</div>
                    <div className={styles.meta}>
                      {b.direction}
                      {b.direction?.length > 0 &&
                        b.break_type?.length > 0 &&
                        ", "}
                      {b.break_type}
                    </div>
                    <div className={styles.description}>
                      <Truncate chars={470} more moreText="more">
                        {b.description}
                      </Truncate>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Container>
        </div>
      </ModalFull>
    </>
  );
}

SurfBreaks.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  breaks: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      image: PropTypes.shape({
        url: PropTypes.string,
        content_type: PropTypes.string,
        byte_size: PropTypes.number,
      }),
      direction: PropTypes.string,
      break_type: PropTypes.string,
      description: PropTypes.string,
    })
  ).isRequired,
};
